<div class="floating-legend" [class.floating-legend-collapsed]="isHidden">
    <div *ngIf="!isHidden" class="flex justify-content-between">
        <div>
            <h5>Monitoramentos</h5>
        </div>
        <div>
            <button pButton pRipple type="button" (click)="toggleMonitoramento()"
                icon="pi pi-arrow-down" pTooltip="Ocultar" class="p-button-rounded p-button-text"></button>
        </div>
    </div>

    <div *ngIf="isHidden" class="floating-legend-collapsed-content">
        <button pButton pRipple type="button" (click)="toggleMonitoramento()" icon="pi pi-arrow-up"
            label="Exibir" class="p-button-text p-button-sm"></button>
    </div>

    <ul *ngIf="isHidden == false">
        <li><i class="fa-regular fa-circle-dot mr-2" style="color: red;"></i> Monitoramento Integração/Coleta</li>
        <li><i class="fa-regular fa-circle-dot mr-2" style="color: orange;"></i> Monitoramento Bateria/Painel</li>
        <li><i class="fa-regular fa-circle-dot mr-2" style="color: blue;"></i> Monitoramento Nível</li>
        <li><i class="fa-regular fa-circle-dot mr-2" style="color: gray;"></i> Monitoramento Chuva</li>
    </ul>

    <div *ngIf="isHidden == false" class="floating-legend-divider"></div>

    <div *ngIf="isHidden == false" class="floating-legend-section">
        <h6>Legenda de cores - Integração</h6>

        <div class="legend-scale-grid">
            <div class="legend-scale-item legend-scale-item-success">
                <strong>Maior que 90%</strong>
            </div>
            <div class="legend-scale-item legend-scale-item-warning">
                <strong>Entre o mínimo da estação e 90%</strong>
            </div>
            <div class="legend-scale-item legend-scale-item-danger">
                <strong>Abaixo do mínimo da estação</strong>
            </div>
            <div class="legend-scale-item legend-scale-item-disabled">
                <strong>Sensor não Instalado ou Desativado</strong>
            </div>
        </div>
        <p class="legend-scale-note">O mínimo é o valor de registros no dia cadastrado na estação. Sem esse valor, o limite continua 80%.</p>
    </div>
</div>
<div class="card resumo-evento-container">
    <p-toolbar styleClass="mb-4 resumo-evento-toolbar">
        <div class="formgrid p-fluid grid col-12 ">
            <div class="field field-label-top col-12 md:col-12 xl:col-3">
                <label for="estacao_id">Estação</label>
                <p-multiSelect inputId="estacao_id" [options]="dropDownEstacao" [filter]="true"
                    filterLocale="pt-BR" [(ngModel)]="estacao_id" optionLabel="label" styleClass="w-full">
                </p-multiSelect>
            </div>

            <div class="field field-label-top col-12 md:col-12 xl:col-4">
                <label for="range">Periodo</label>
                <p-datepicker appendTo="body" dateFormat="dd/mm/yy" placeholder="Periodo"
                    [(ngModel)]="rangeDate" selectionMode="range" inputId="range" styleClass="w-full">
                </p-datepicker>
                <small id="periodo-help"  class="p-error">Periodo é
                    obrigatório para filtrar.</small>
            </div>

            <div *ngIf="exibirFiltroAvancado" class="formgrid p-fluid grid col-12">
                <div class="field col-12 md:col-12 xl:col-4">
                    <p-multiSelect [options]="dropDownGrupos" appendTo="body" [filter]="true" [(ngModel)]="grupo"
                        optionLabel="label" placeholder="Grupos">
                    </p-multiSelect>
                </div>

                <div class="field col-12 md:col-12 xl:col-4">
                    <p-multiSelect [options]="dropDownClientes" appendTo="body" [filter]="true" [(ngModel)]="cliente"
                        optionLabel="label" placeholder="Cliente">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12 xl:col-4">
                    <p-multiSelect [options]="dropDownSensores" appendTo="body" [filter]="true" [(ngModel)]="sensor"
                        optionLabel="label" placeholder="Sensores (Identificador)">
                    </p-multiSelect>
                </div>

                <div class="field col-12 md:col-12 xl:col-3">
                    <input type="text" class="date-input" placeholder="PLU" [(ngModel)]="plu_filtro" pInputText>
                </div>
                <div class="field col-12 md:col-12 xl:col-3">
                    <input type="text" class="date-input" placeholder="FLU" [(ngModel)]="flu_filtro" pInputText>
                </div>
                <div class="field col-12 md:col-12 xl:col-3">
                    <p-multiSelect [options]="dropDownIntegradores" appendTo="body" [filter]="true"
                        [(ngModel)]="integrador_filtro" optionLabel="descricao" placeholder="Integrador">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12 xl:col-3">
                    <input type="text" class="date-input" placeholder="Coletor" [(ngModel)]="coletor_filtro" pInputText>
                </div>

                <div class="field col-12 md:col-12 xl:col-3">
                    <button pButton pRipple type="button" label="Novo grupo de estação" (click)="addNovoGrupo()"
                        icon="pi pi-plus" class="p-button-success"></button>
                </div>
            </div>

            <div class="field col-12 md:col-12 xl:col-2 mt-3 resumo-toolbar-acoes">
                <button *ngIf="load == false" [disabled]="rangeDate.length == 0" pButton pRipple pTooltip="Filtrar"
                    (click)="filtrar()" type="button" icon="pi pi-search"
                    class="p-button-rounded p-button-success"></button>
                <button pButton pRipple type="button" (click)="toggleFiltroAvancado()" pTooltip="Filtro avançado"
                    icon="pi pi-filter" class="p-button-rounded p-button-text p-button-plain ml-2"></button>
                <button *ngIf="load == false" [disabled]="data.length == 0" pButton pRipple pTooltip="Gerar Relatório para Impressão"
                    (click)="abrirRelatorio()" type="button" icon="pi pi-print"
                    class="p-button-rounded p-button-info ml-2"></button>
                <button *ngIf="load == false" [disabled]="rangeDate.length == 0" pButton pRipple pTooltip="Abrir Relatório Analítico de Eventos"
                    (click)="abrirRelatorioEventos()" type="button" icon="pi pi-chart-bar"
                    class="p-button-rounded p-button-help ml-2"></button>
                <p-progressSpinner *ngIf="load" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
                    strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
            </div>

            <div class="field col-12 md:col-12 xl:col-3 mt-3 resumo-totalizador-estacoes"
                [class.resumo-totalizador-estacoes--diverge]="totalizadorEstacoesDiverge">
                <div *ngIf="!load" class="resumo-totalizador-estacoes__conteudo">
                    <div class="resumo-totalizador-estacoes__item">
                        <span class="resumo-totalizador-estacoes__valor">{{ totalEstacoesApi }}</span>
                        <span class="resumo-totalizador-estacoes__rotulo">Estações filtro</span>
                    </div>
                    <div class="resumo-totalizador-estacoes__divisor"></div>
                    <div class="resumo-totalizador-estacoes__item resumo-totalizador-estacoes__item--exibidas">
                        <span class="resumo-totalizador-estacoes__valor">{{ totalEstacoesExibidas }}</span>
                        <span class="resumo-totalizador-estacoes__rotulo">Exibindo na grid</span>
                    </div>
                </div>
            </div>

            <div class="field col-12 mt-3">
                <div class="grid-toolbar-linha-versao-busca">
                    <span class="grid-busca-input">
                        <i class="pi pi-search grid-busca-icon"></i>
                        <input pInputText type="text"
                            [(ngModel)]="buscaGrid"
                            (ngModelChange)="onBuscaGridChange()"
                            [disabled]="data.length === 0"
                            placeholder="Buscar na grid (estação, eventos, monitoramentos, datas...)" />
                    </span>
                    <div class="grid-filtros-conteudo">
                        <button pButton pRipple type="button"
                            class="p-button-outlined grid-filtro-toggle-btn"
                            [class.grid-filtro-toggle-btn--ativo]="filtroGridComMonitoramento"
                            [disabled]="data.length === 0"
                            pTooltip="Exibir somente estações com monitoramento no período"
                            tooltipPosition="top"
                            (click)="toggleFiltroGridComMonitoramento()">
                            <i class="pi pi-flag mr-1"></i>
                            Com monitoramento
                        </button>
                        <button *ngIf="filtroGridComMonitoramento"
                            pButton pRipple type="button"
                            class="p-button-outlined grid-filtro-toggle-btn"
                            [class.grid-filtro-toggle-btn--ativo]="filtroGridMonitoramentoAberto"
                            [disabled]="data.length === 0"
                            pTooltip="Exibir somente monitoramentos em aberto"
                            tooltipPosition="top"
                            (click)="toggleFiltroGridMonitoramentoAberto()">
                            <i class="pi pi-clock mr-1"></i>
                            Em aberto
                        </button>
                    </div>
                    <div class="flex align-items-center versao-radios">
                        <input type="radio" id="versao0" name="versao" value="0" [(ngModel)]="versao" (change)="onVersaoChange()" class="mr-2">
                        <label for="versao0" class="mr-3">Simplificado</label>

                        <input type="radio" id="versao1" name="versao" value="1" [(ngModel)]="versao" (change)="onVersaoChange()" class="mr-2">
                        <label for="versao1">Completo</label>
                    </div>
                </div>
            </div>
        </div>


    </p-toolbar>

    <div class="resumo-evento-table-wrapper" #tableWrapper>
        <p-table #dt [columns]="columns" [value]="dataGridExibida"
            [styleClass]="'fixed-row-table p-datatable-gridlines ' + (versao === '1' ? 'resumo-versao-completa' : 'resumo-versao-simplificada')"
            [scrollable]="true" [scrollHeight]="scrollHeight" [tableStyle]="{'min-width': tableMinWidth}" [virtualScroll]="true"
            [virtualScrollItemSize]="virtualRowHeight" [rowTrackBy]="trackByEstacao">

        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="fixed-column-left coluna-estacao" pFrozenColumn>Estação</th>
                <th *ngFor="let col of columns">
                    {{col.header}}
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <!-- PONTO-RETORNO-LINHA-PREVIEW: class/mouseleave na linha -->
            <tr [class.resumo-linha-preview-completa]="linhaEstaEmPreviewCompleta(rowData)"
                (mouseleave)="onMouseLeaveLinhaGrid(rowData)">
                <td class="fixed-column-left coluna-estacao" pFrozenColumn>
                    <a *ngIf="permissaoService.can('estacoes_visualizar'); else nomeEstacaoTexto"
                        class="link-estacao"
                        [routerLink]="['/dashboard', rowData.estacao_id, 'grafico']"
                        [queryParams]="getDashboardQueryParams()"
                        (click)="prepararNavegacaoGraficos(rowData)">
                        {{rowData['descricao']}}
                    </a>
                    <ng-template #nomeEstacaoTexto>
                        {{rowData['descricao']}}
                    </ng-template>
                </td>

                <!-- PONTO-RETORNO-LINHA-PREVIEW: click na célula do dia -->
                <td *ngFor="let col of columns"
                    class="celula-dia-grid"
                    [class.celula-dia-grid-clicavel]="versao === '0'"
                    [class.celula-dia-grid-completa]="exibirConteudoCompletoLinha(rowData)"
                    [class.celula-dia-grid-simplificada]="!exibirConteudoCompletoLinha(rowData)"
                    [style.background]="getBackgroundColorForDay(rowData, col.data_resumo)"
                    (click)="onClicarCelulaDiaGrid(rowData, $event)">

                    <div class="celula-dia-inner">
                        <ng-container *ngIf="exibirConteudoCompletoLinha(rowData)">
                            <div class="celula-dia-bloco celula-dia-bloco-icones">
                                <div class="celula-dia-secao celula-dia-secao-eventos">
                                    <span class="celula-dia-etiqueta">Eventos</span>
                                    <div class="celula-dia-icones-grupo">
                                        <ng-container *ngIf="hasEventosNaData(rowData, col.data_resumo); else semEventosDia">
                                            <i *ngFor="let row of getEventosNaData(rowData, col.data_resumo)"
                                                class="celula-dia-icone"
                                                [title]="row.tipo_evento.descricao"
                                                [ngClass]="getIconeEvento(row)"
                                                [ngStyle]="{'color': row.cor}"></i>
                                        </ng-container>
                                        <ng-template #semEventosDia>
                                            <span class="celula-dia-vazio">Sem eventos dia</span>
                                        </ng-template>
                                    </div>
                                </div>
                                <div class="celula-dia-secao celula-dia-secao-monitoramento">
                                    <span class="celula-dia-etiqueta">Monit.</span>
                                    <div class="celula-dia-icones-grupo celula-dia-icones-grupo-monitoramento"
                                        [ngClass]="getClassesFaixaMonitoramento(rowData, col.data_resumo)"
                                        [title]="getTooltipFaixaMonitoramento(rowData, col.data_resumo)"
                                        (click)="onClicarFaixaMonitoramento(col, rowData, $event)">
                                        <ng-container *ngIf="getMonitoramentosIconesNaData(rowData, col.data_resumo).length > 0; else semMonitoramentosDia">
                                            <i *ngFor="let cat of getMonitoramentosIconesNaData(rowData, col.data_resumo)"
                                                class="celula-dia-icone"
                                                [ngClass]="cat.icone"
                                                [ngStyle]="{'color': cat.cor}"
                                                [title]="cat.label"></i>
                                        </ng-container>
                                        <ng-template #semMonitoramentosDia>
                                            <span class="celula-dia-vazio">Sem monitoramentos dia</span>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="getEventoColetaNaData(rowData, col.data_resumo) as eventoColeta">
                            <div class="celula-dia-bloco celula-dia-bloco-percentuais">
                                <div class="percentuais-resumo">
                                    <small *ngIf="exibirConteudoCompletoLinha(rowData)" class="percentual-linha">
                                        <span class="percentual-chave">Disp.</span> {{ eventoColeta.disponibilidade }}
                                    </small>
                                    <small *ngIf="exibirConteudoCompletoLinha(rowData)" class="percentual-linha">
                                        <span class="percentual-chave">Atraso</span> {{ eventoColeta.atraso_medio_integracao || 'N/A' }}
                                    </small>
                                    <small class="percentual-linha">
                                        <span class="percentual-chave">Coleta</span> {{ eventoColeta.percentual_coleta || '0,00 %' }}
                                    </small>
                                    <small class="percentual-linha">
                                        <span class="percentual-chave">Integr.</span>
                                        {{ integracaoDesligada(rowData) ? 'Desligado' : eventoColeta.percentual_integracao }}
                                    </small>
                                </div>
                            </div>
                        </ng-container>

                        <div *ngIf="exibirConteudoCompletoLinha(rowData)" class="celula-dia-bloco celula-dia-bloco-acoes">
                            <button pButton pRipple type="button"
                                [disabled]="permissaoService.can('resumo_eventos_visualizar_eventos_monitoramentos') == false"
                                (click)="selectDayEventosMonitoramentos(col, rowData); $event.stopPropagation()"
                                label="Eventos/Monitoramentos"
                                class="celula-dia-btn-acao"></button>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
        </p-table>
    </div>
</div>


<p-dialog *ngIf="modalEventosMonitoramentos" [(visible)]="modalEventosMonitoramentos"
    [breakpoints]="{'960px': '90vw', '640px': '100vw'}" [style]="{width: '90vw', 'max-width': '1400px'}" styleClass="resumo-eventos-modal">
    <ng-template pTemplate="header">
        <a [routerLink]="['/dashboard/', estacaoSelecionada, data_monitoramento]"
            style="cursor: pointer; text-decoration: none; color: inherit;">
            <h5>
                {{ tituloModal }}
            </h5>
        </a>
    </ng-template>
    
    <div class="container">
        <div class="p-fluid grid">
            <div *ngIf="loading || !modalMonitoramentoPronto" class="p-fluid grid col-12 modalMonitoramento justify-content-center py-4">
                <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="8"
                    fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
            </div>

            <div *ngIf="modalMonitoramentoPronto" class="col-12">
                <!-- Card de Botões -->
                <div class="buttons-card mb-3 p-p-3 p-shadow-2">
                    <div class="col-12 md:col-12 xl:col-12 p-fluid grid">
                        <div class="col-12 md:col-3 xl:col-3">
                            <button pButton pRipple type="button"
                                class="p-button p-button-warning mr-2 p-button-block"
                                (click)="cancelarMonitoramento()">
                                <i class="pi pi-times mr-2"></i>
                                Cancelar
                            </button>
                        </div>
                        
                        <div class="col-12 md:col-3 xl:col-3">
                            <button pButton pRipple type="button"
                                class="p-button p-button-danger mr-2 p-button-block"
                                (click)="salvarMonitoramento('encerrar')"
                                [disabled]="!podeSalvarEncerrar">
                                <i class="pi pi-save mr-2"></i>
                                Salvar e Encerrar
                            </button>
                        </div>
                        
                        <div class="col-12 md:col-3 xl:col-3">
                            <button pButton pRipple type="button"
                                class="p-button p-button-success mr-2 p-button-block"
                                (click)="salvarMonitoramento('abrir')"
                                [disabled]="!podeSalvar">
                                <i class="pi pi-check mr-2"></i>
                                Salvar
                            </button>
                        </div>
                        
                        <div class="col-12 md:col-3 xl:col-3">
                            <button pButton pRipple type="button"
                                class="p-button p-button-info mr-2 p-button-block"
                                (click)="enviarEmailEstacao()"
                                [disabled]="!podeEnviarEmailUi"
                                [loading]="loadingEnviarEmail">
                                <i class="pi pi-send mr-2"></i>
                                Enviar E-mail
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Card de Monitoramento -->
                <div class="monitoring mb-3 p-p-3 p-shadow-2">
                    <h4 style="text-align: center;">MONITORAMENTO</h4>
                    <div class="p-fluid grid col-12 mb-3">
                        <div class="col-12 md:col-6">
                            <div class="p-fluid grid">
                                <div class="field col-12 mb-2">
                                    <label for="data_hora_monitoramento" class="monitoring-field-label">Data/Hora início do MONITORAMENTO</label>
                                    <p-datepicker 
                                        [(ngModel)]="novoMonitoramento.data_hora_monitoramento" 
                                        [showTime]="true" 
                                        dateFormat="dd/mm/yy"
                                        [showIcon]="true"
                                        inputId="data_hora_monitoramento"
                                        [maxDate]="maxDate"
                                        [disabled]="monitoramentoFechado"
                                        (onSelect)="onMonitoramentoDataChange()"
                                        [required]="true"
                                        styleClass="monitoring-date-input">
                                    </p-datepicker>
                                    <small class="p-error" *ngIf="!novoMonitoramento.data_hora_monitoramento">
                                        Campo obrigatório
                                    </small>
                                </div>
                                
                                <div class="field col-12">
                                    <div class="monitoring-date-fim-header">
                                        <label for="data_hora_ultima_situacao" class="monitoring-field-label mb-0">Data/Hora Fim monitoramento</label>
                                        <button
                                            type="button"
                                            pButton
                                            pRipple
                                            label="Em aberto"
                                            class="p-button-text p-button-sm monitoring-em-aberto-btn"
                                            [ngClass]="{'monitoring-em-aberto-btn--active': monitoramentoSemDataFim}"
                                            [disabled]="monitoramentoFechado"
                                            [pTooltip]="monitoramentoSemDataFim
                                                ? 'Monitoramento sem data de encerramento'
                                                : 'Clique para manter o monitoramento em aberto (limpar data fim)'"
                                            tooltipPosition="top"
                                            (click)="limparDataFimMonitoramento()">
                                        </button>
                                    </div>
                                    <p-datepicker 
                                        [(ngModel)]="novoMonitoramento.data_hora_ultima_situacao" 
                                        [showTime]="true" 
                                        dateFormat="dd/mm/yy"
                                        [showIcon]="true"
                                        [showClear]="true"
                                        inputId="data_hora_ultima_situacao"
                                        [minDate]="minDateEvento"
                                        [maxDate]="maxDate"
                                        [disabled]="monitoramentoFechado"
                                        (onSelect)="onMonitoramentoFimDataChange()"
                                        (onClear)="onMonitoramentoFimDataChange()"
                                        styleClass="monitoring-date-input">
                                    </p-datepicker>
                                    <small class="p-text-muted">
                                        Obrigatório apenas ao finalizar o monitoramento
                                    </small>
                                </div>
                                
                                <div class="field col-12 mt-2">
                                    <div class="p-checkbox monitoring-checkbox-row">
                                        <p-checkbox 
                                            [(ngModel)]="novoMonitoramento.monitoramento_interno" 
                                            inputId="monitoramento_interno"
                                            [binary]="true">
                                        </p-checkbox>
                                        <label for="monitoramento_interno" class="p-checkbox-label ml-2">
                                            Monitoramento interno
                                        </label>
                                    </div>
                                    <small class="p-text-muted block mt-1">
                                        Quando marcado, os e-mails serão enviados apenas para usuários internos.
                                    </small>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6">
                            <div class="p-fluid grid">
                                <div class="field col-12">
                                    <label for="observacao_abertura" class="monitoring-field-label">Observação de Abertura (opcional)</label>
                                    <textarea 
                                        pTextarea 
                                        id="observacao_abertura"
                                        class="monitoring-textarea"
                                        [(ngModel)]="novoMonitoramento.observacao_abertura" 
                                        rows="5"
                                        placeholder="Descreva observações sobre a abertura do monitoramento..."
                                        (focus)="onCampoTextoFocus()"
                                        (blur)="onCampoTextoBlur()">
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Card de Eventos -->
                <div class="events">
                    <h4 style="text-align: center;">EVENTOS</h4>
                    
                    <div class="p-fluid grid col-12">
                        <p-message *ngIf="eventosDataSelecionada.length == 0" severity="info"
                            text="Nenhum evento encontrado."></p-message>
                        
                        <div *ngFor="let row of eventosDataSelecionada; let i = index; trackBy: trackByEventoModal"
                            class="formgrid p-fluid grid col-12 flex mb-2 p-p-1 p-shadow-1 event-row-container">
                            
                            <div class="col-1 flex align-items-center justify-content-center">
                                <i [class]="row.iconeCss"
                                [style.color]="row.cor"
                                style="font-size: 20px"></i>
                            </div>
                            <div class="col-5 flex align-items-center">
                                <span style="font-size: 14px; font-weight: 600; color: #495057;">
                                    {{ row.tipo_evento.descricao }}
                                </span>
                            </div>
                            <div class="col-3 flex align-items-center justify-content-end">
                                <span [pTooltip]="row.tooltip" 
                                    style="font-size: 13px; font-weight: 500; color: #6c757d;">
                                    {{ row.total_computado }} / {{ row.maximo_normalidade_eventos }}
                                </span>
                            </div>
                            
                            <div class="col-3 flex align-items-center justify-content-end">
                                <div class="field-checkbox">
                                    <p-checkbox 
                                        [(ngModel)]="row.selecionadoParaMonitoramento"
                                        [binary]="true"
                                        inputId="monitoramento{{i}}"
                                        label="Monitoramento"
                                        (onChange)="onSelecionarMonitoramento(row, $event)">
                                    </p-checkbox>
                                </div>
                            </div>
                            
                            <div *ngIf="row.selecionadoParaMonitoramento && modalMonitoramentoPronto" class="col-12 p-fluid grid mt-1">
                                <div class="col-12 p-fluid grid event-monitoring-fields">
                                    <div class="field col-12 md:col-2">
                                        <label for="data_hora_inicio{{i}}" class="monitoring-field-label monitoring-field-label-sm">Data/Hora Início</label>
                                        <p-datepicker 
                                            [(ngModel)]="row.data_hora_inicio" 
                                            [showTime]="true" 
                                            dateFormat="dd/mm/yy"
                                            [showIcon]="true"
                                            inputId="data_hora_inicio{{i}}"
                                            [minDate]="minDateEvento"
                                            [maxDate]="maxDateEvento"
                                            (onSelect)="atualizarEstadoUiMonitoramento()"
                                            styleClass="compact-calendar-inline monitoring-date-input-sm">
                                        </p-datepicker>
                                    </div>
                                    
                                    <div class="field col-12 md:col-2">
                                        <div class="monitoring-date-fim-header">
                                            <label for="data_hora_fim{{i}}" class="monitoring-field-label monitoring-field-label-sm mb-0">Data/Hora Fim</label>
                                            <button
                                                type="button"
                                                pButton
                                                pRipple
                                                label="Em aberto"
                                                class="p-button-text p-button-sm monitoring-em-aberto-btn"
                                                [ngClass]="{'monitoring-em-aberto-btn--active': row.emAberto}"
                                                [pTooltip]="row.emAberto
                                                    ? 'Evento sem data de encerramento'
                                                    : 'Clique para manter o evento em aberto (limpar data fim)'"
                                                tooltipPosition="top"
                                                (click)="limparDataFimEvento(row)">
                                            </button>
                                        </div>
                                        <p-datepicker 
                                            [(ngModel)]="row.data_hora_fim" 
                                            [showTime]="true" 
                                            dateFormat="dd/mm/yy"
                                            [showIcon]="true"
                                            [showClear]="true"
                                            placeholder="Opcional"
                                            inputId="data_hora_fim{{i}}"
                                            [minDate]="row.minDateFim"
                                            [maxDate]="maxDateEvento"
                                            (onSelect)="atualizarEstadoUiMonitoramento()"
                                            (onClear)="atualizarEstadoUiMonitoramento()"
                                            styleClass="compact-calendar-inline monitoring-date-input-sm">
                                        </p-datepicker>
                                    </div>
                                    
                                    <div class="field col-12 md:col-4">
                                        <label class="monitoring-field-label monitoring-field-label-sm">Problema (opcional)</label>
                                        <input 
                                            [id]="'problema_' + i"
                                            pInputText 
                                            class="monitoring-text-input-sm"
                                            [(ngModel)]="row.problema" 
                                            placeholder="Descreva o problema..."
                                            (focus)="onCampoTextoFocus()"
                                            (blur)="onCampoTextoBlur()">
                                    </div>
                                    
                                    <div class="field col-12 md:col-4">
                                        <label class="monitoring-field-label monitoring-field-label-sm">Desfecho (opcional)</label>
                                        <input 
                                            [id]="'desfecho_' + i"
                                            pInputText 
                                            class="monitoring-text-input-sm"
                                            [(ngModel)]="row.desfecho" 
                                            placeholder="Descreva o desfecho..."
                                            (focus)="onCampoTextoFocus()"
                                            (blur)="onCampoTextoBlur()">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- <div *ngIf="!modoMonitoramentoAtivo && temEventosSelecionados()" 
                     class="col-12 mt-3 p-text-center">
                    <button pButton pRipple type="button"
                        class="p-button p-button-primary"
                        (click)="ativarModoMonitoramento()">
                        <i class="pi pi-plus mr-2"></i>
                        Abrir Monitoramento
                    </button>
                </div> -->
                
                <!-- <div *ngIf="!modoMonitoramentoAtivo && !temEventosSelecionados() && eventosDataSelecionada.length > 0" 
                     class="col-12 mt-3 p-text-center">
                    <p-message severity="info" 
                              text="Selecione pelo menos um evento para habilitar o monitoramento."></p-message>
                </div> -->
            </div>
        </div>
    </div>
</p-dialog>
<p-dialog [(visible)]="modalNovoGrupo" header="Novo Grupo de estações"
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}">
    <app-grupo-estacao-formulario (onSave)="aoSalvarNovoGrupo()"></app-grupo-estacao-formulario>
</p-dialog>

<p-toast></p-toast>
